import { useState } from 'react'
import { AdminShell, AdminButton, AdminAlert, AdminInput } from './AdminShared'
import { adminForgotPassword } from '../../services/admin'

export default function AdminForgotPassword() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [sent, setSent] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    if (!email.trim()) { setError('Please enter your admin email.'); return }
    setLoading(true)
    try {
      await adminForgotPassword(email.trim())
      setSent(true)
    } catch (err) {
      setError(err.message || 'Failed to send reset email. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <AdminShell>
      <div className="w-full max-w-[480px]">
        <div
          className="bg-surface border-[4px] border-on-background p-8 flex flex-col gap-6"
          style={{ boxShadow: '8px 8px 0px 0px #000' }}
        >
          <div className="text-center flex flex-col items-center gap-3">
            <div
              className="w-16 h-16 bg-on-surface border-[4px] border-on-surface flex items-center justify-center"
              style={{ boxShadow: '4px 4px 0px 0px #d4af37' }}
            >
              <span
                className="material-symbols-outlined text-[32px] text-surface"
                style={{ fontVariationSettings: "'FILL' 1" }}
              >
                lock_reset
              </span>
            </div>
            <h1 className="font-extrabold text-[28px] uppercase tracking-tight leading-none text-on-surface">
              Reset Password
            </h1>
            <p className="text-on-surface-variant font-medium text-[14px]">
              Enter your admin email and we'll send a reset link.
            </p>
          </div>

          {error && <AdminAlert type="error" message={error} />}

          {sent ? (
            <div className="flex flex-col gap-4">
              <AdminAlert
                type="success"
                message="Reset link sent. Check your inbox and follow the instructions."
              />
              <a
                href="/portal-ax92-v1"
                className="block text-center font-bold text-[11px] uppercase tracking-widest text-on-surface-variant hover:text-on-surface transition-colors"
              >
                ← Back to login
              </a>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="flex flex-col gap-5">
              <AdminInput
                id="email"
                label="Admin Email"
                type="email"
                placeholder="Enter your admin email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                disabled={loading}
              />
              <AdminButton type="submit" loading={loading}>
                <span className="material-symbols-outlined text-[18px]">send</span>
                Send Reset Link
              </AdminButton>
              <a
                href="/portal-ax92-v1"
                className="block text-center font-bold text-[11px] uppercase tracking-widest text-on-surface-variant hover:text-on-surface transition-colors"
              >
                ← Back to login
              </a>
            </form>
          )}
        </div>
      </div>
    </AdminShell>
  )
}
